<div [ngSwitch]="message.service_type" class="d-flex my-4 w-100 align-items-center justify-content-center">
  <ng-template ngSwitchCase="group_chat_created">
    <div *ngIf="Service.openChat.is_creator" class="bg-secondary px-4 py-3 rounded-lg shadow-sm">
      <h5 class="text-center">Вы создали группу.</h5>
      <div>Возможности групп:</div>
      <div class="pl-2">
        <div>
          <i-feather name="users" class="mr-2"></i-feather>
          До 200 000 участников
        </div>
        <div>
          <i-feather name="clock" class="mr-2"></i-feather>
          Общая история переписки
        </div>
        <div>
          <i-feather name="link-2" class="mr-2"></i-feather>
          Публичные ссылки вида t.me/title
        </div>
        <div>
          <i-feather name="lock" class="mr-2"></i-feather>
          Разный уровень прав
        </div>
      </div>
    </div>
    <div *ngIf="!Service.openChat.is_creator" class="col-auto">
      <span class="badge badge-lg badge-secondary rounded-lg shadow-sm"
        >{{ message?.name?.first }} создал(а) группу «{{ Service.openChat.title }}».</span
      >
    </div>
  </ng-template>
  <ng-template ngSwitchCase="supergroup_chat_created">
    <div *ngIf="Service.openChat.is_creator" class="bg-secondary px-4 py-3 rounded-lg shadow-sm">
      <h5 class="text-center">Вы создали супергруппу.</h5>
      <div>Возможности групп:</div>
      <div class="pl-2 mb-3">
        <div>
          <i-feather name="users" class="mr-2"></i-feather>
          До 200 000 участников
        </div>
        <div>
          <i-feather name="clock" class="mr-2"></i-feather>
          Общая история переписки
        </div>
        <div>
          <i-feather name="link-2" class="mr-2"></i-feather>
          Публичные ссылки вида t.me/title
        </div>
        <div>
          <i-feather name="lock" class="mr-2"></i-feather>
          Разный уровень прав
        </div>
      </div>
      <div>Ключевые особенности супергрупп:</div>
      <div class="pl-2">
        <div>
          <i-feather name="clock" class="mr-2"></i-feather>
          Новым пользователям доступна вся история переписки группы.
        </div>
        <div>
          <i-feather name="trash-2" class="mr-2"></i-feather>
          Удалённые сообщения удаляются у всех пользователей.
        </div>
        <div>
          <i-feather name="lock" class="mr-2"></i-feather>
          Обычные пользователи (не-администраторы) могут удалять только свои сообщения.
        </div>
        <div>
          <i-feather name="volume-2" class="mr-2"></i-feather>
          В супергруппах по умолчанию отключены уведомления (и вообще они реже уведомляют о различных событиях).
        </div>
      </div>
    </div>
    <div *ngIf="!Service.openChat.is_creator" class="col-auto">
      <span class="badge badge-lg badge-secondary rounded-lg shadow-sm"
        >{{ message?.name?.first }} создал(а) супергруппу «{{ Service.openChat.title }}»</span
      >
    </div>
  </ng-template>
  <ng-template ngSwitchCase="channel_chat_created">
    <span *ngIf="Service.openChat.is_creator" class="badge badge-lg badge-secondary rounded-lg shadow-sm"
      >Канал «{{ Service.openChat.title }}» создан</span
    >
    <span *ngIf="!Service.openChat.is_creator" class="badge badge-lg badge-secondary rounded-lg shadow-sm"
      >{{ message?.name?.first }} создал(а) канал «{{ Service.openChat.title }}»</span
    >
  </ng-template>
  <ng-template ngSwitchCase="new_chat_title">
    <span *ngIf="Service.openChat.is_creator" class="badge badge-lg badge-secondary rounded-lg shadow-sm"
      >Вы изменили название группы на «{{ message.new_chat_title }}»</span
    >
    <span *ngIf="!Service.openChat.is_creator" class="badge badge-lg badge-secondary rounded-lg shadow-sm"
      >{{ message?.name?.first }} изменил(а) название группы на «{{ message.new_chat_title }}»</span
    >
  </ng-template>
  <ng-template ngSwitchCase="new_chat_members">
    <div>
      <span *ngIf="Service.openChat.is_creator" class="badge badge-lg badge-secondary rounded-lg shadow-sm"
        ><i-feather name="user-plus"></i-feather> Вы добавли
        {{ appService.declOfNum(message?.service_users.length, ['# участник', '# участника', '# участников']) }}</span
      >
      <span *ngIf="!Service.openChat.is_creator" class="badge badge-lg badge-secondary rounded-lg shadow-sm"
        ><i-feather name="user-plus"></i-feather>
        {{
          appService.declOfNum(message?.service_users.length, [
            'Новый участник',
            'Новые # участника',
            'Новых # участников'
          ])
        }}</span
      >
      <ng-template [ngTemplateOutlet]="users"></ng-template>
    </div>
  </ng-template>
  <ng-template ngSwitchCase="left_chat_member">
    <div>
      <span *ngIf="Service.openChat.is_creator" class="badge badge-lg badge-secondary rounded-lg shadow-sm"
        ><i-feather name="user-x"></i-feather> Вы исключили участника</span
      >
      <span *ngIf="!Service.openChat.is_creator" class="badge badge-lg badge-secondary rounded-lg shadow-sm"
        ><i-feather name="user-x"></i-feather> Исключен участник</span
      >
      <ng-template [ngTemplateOutlet]="users"></ng-template>
    </div>
  </ng-template>

  <ng-template ngSwitchCase="pinned_message">
    <span
      (click)="openMessages([message.pinned_message])"
      [innerHTML]="message?.text"
      class="badge badge-lg badge-secondary rounded-lg shadow-sm pointer"
    >
    </span>
  </ng-template>

  <ng-template ngSwitchCase="contact_registered">
    <div class="bg-secondary px-4 py-3 rounded-lg shadow-sm">
      <h5 class="text-center" [innerHTML]="message?.text"></h5>
      <div>
        <strong [innerHTML]="message?.name?.first | replaceEmojis: 'facebook':24:64"></strong> из ваших контактов. <br>
        Вы можете написать ему или прислать смайл приветствия</div>

      <div (click)="sendMessage()" class="text-center my-3">
        <ngx-emoji [emoji]="{ id: 'wave', skin: 3 }" size="80"></ngx-emoji>
      </div>
    </div>
  </ng-template>
  <ng-template ngSwitchCase="call_missed_voice">
    <span class="badge badge-lg badge-secondary rounded-lg shadow-sm">
      <a
        class="pointer"
        href="javascript:void(0)"
        (click)="openDetailInfo(Service.openChat.id)"
        [innerHTML]="message?.name?.first | replaceEmojis: 'facebook':24:64"
      ></a
      >&nbsp;Пропущенный звонок, пока не поддерживается...
    </span>
  </ng-template>

  <ng-template ngSwitchCase="hidden"></ng-template>

  <ng-template ngSwitchDefault>
    <div *ngIf="index > 0">
      <span class="badge badge-lg badge-secondary rounded-lg shadow-sm">
        <ng-template [ngIf]="message.text" [ngIfElse]="undefinedMessage">{{ message.text }}</ng-template>
        <ng-template #undefinedMessage>
          <a
            class="pointer"
            href="javascript:void(0)"
            (click)="openDetailInfo(Service.openChat.id)"
            [innerHTML]="message?.name?.first | replaceEmojis: 'facebook':24:64"
          ></a
          >&nbsp;Звонок, пока не поддерживается...
        </ng-template>
      </span>
      <ng-template [ngTemplateOutlet]="users"></ng-template>
    </div>
  </ng-template>
</div>

<ng-template #users>
  <div class="d-flex justify-content-center mt-3">
    <app-avatar-user
      *ngFor="let user of message?.service_users; let i = index"
      [Service]="Service"
      [user]="user"
    ></app-avatar-user>
  </div>
</ng-template>
